<template>
    <v-layout row justify-center>
        <v-dialog v-model="dialog" persistent max-width="600px">
            <template v-slot:activator="{ on }">
                <a @click="dialog = true" style="margin-left: 33px; font-size: 14px;"> {{$t("Forgot your password?")}}</a>
            </template>
            <v-card>
                <v-card-title>
                    <div style="padding: 24px 24px 0 24px">
                        <span class="headline">{{$t("Forgot Password")}}</span>
                    </div>
                </v-card-title>
                <v-card-text>
                    <v-container grid-list-md style="padding-top: 0px;">

                        <v-alert @logsucces="alert('logsucces')" outline style="text-align: left;" class="mb-3"
                                 :value="alert.visible"
                                 :type="alert.type" >
                            {{alert.text}}
                        </v-alert>

                        <v-layout wrap>
                            <div>{{$t("Enter your email address and we'll help you reset your password.")}}</div>
                            <v-flex xs12>
                                <v-text-field prepend-icon="email" name="email" :label="$t('Email')" type="text" required v-model="email"></v-text-field>
                            </v-flex>
                        </v-layout>

                    </v-container>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" dark @click="sendForgotPassword()">{{$t('Send')}}</v-btn>
                    <v-btn color="primary" outline @click="dialog = false">{{$t('Close')}}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-layout>
</template>

<script>

    import AuthRepository from "@/repositories/AuthRepository";
    import {VSpacer, VLayout, VDialog, VCard, VCardTitle, VBtn, VCardActions, VTextField, VContainer, VCardText, VFlex, VAlert} from 'vuetify/lib'

    export default {
        components: { VLayout, VDialog, VBtn, VCard, VCardTitle, VCardActions, VTextField, VContainer, VSpacer, VCardText, VFlex, VAlert},
        data: () => ({
            alert: {},
            dialog: false,
            email: "",
        }),

        methods:{
            sendForgotPassword(){
                if(this.email !== ""){
                    AuthRepository.forgotPassword(this.email)
                        .then(() => {
                            this.dialog = false;
                            this.snakeSuccess(this.$t("Email Send!"));
                        }).catch((error) => {
                            this.alertBox(error.response.data.message, "error");
                        });
                }else{
                    this.alertBox(this.$t("Password cannot be empty"));
                }
            },
            snakeSuccess(text){
                this.$root.$emit('show-snackbar', {message: text,color: 'success', timeout: 6000 });
            },
            snakeError(text){
                this.$root.$emit('show-snackbar', {message: text,color: 'error', timeout: 6000 });
            },
            alertBox(text, type) {
                this.alert = {
                    type: type,
                    text: text,
                    visible: true
                }
            }
        }
    }
</script>